import { Routes, Route } from "react-router-dom";
import { ThemeProvider } from "styled-components";

import { theme } from "assets/themes/NoerCare";
import GlobalStyles from "assets/styles/Globals/Globals";
import Header from "components/Header/Header";

import Homepage from "pages/Homepage";
import Diensten from "pages/Diensten";
import OverOns from "pages/OverOns";
import WerkenBij from "pages/WerkenBij";
import Contact from "pages/Contact";


function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Header />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/diensten" element={<Diensten />} />
        <Route path="/over-ons" element={<OverOns />} />
        <Route path="/werken-bij" element={<WerkenBij />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
